import axiosInstance from "@/api/axios-instance";
import { RegionFormData } from "../schema/region-schema";
import { Region } from "../types/region";

export async function createRegion(data: RegionFormData) {
  const response = await axiosInstance.post<Region>("/region", data);
  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to create region");
  }
  return response.data;
}
